import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

/**
 * Allows navigation only if the user is authenticated. Otherwise redirects to /login,
 * preserving the attempted URL as a returnUrl query param.
 *
 * In dev (environment.auth.bypass=true) the guard is a no-op so local development
 * doesn't need a real Cognito pool.
 */
export const authGuard: CanActivateFn = async (_route, state) => {
    if (environment.auth.bypass) return true;

    const auth = inject(AuthService);
    const router = inject(Router);

    const token = await auth.getIdToken();
    if (token) {
        // Keep the signal in sync if APP_INITIALIZER ordering ever changes.
        if (auth.step() !== 'authenticated') {
            auth.step.set('authenticated');
        }
        return true;
    }

    return router.createUrlTree(['/login'], {
        queryParams: { returnUrl: state.url },
    });
};
